// removed by extract-text-webpack-plugin
module.exports = {"smallDeviceMax":"567px","mediumDeviceMin":"568px","mediumDeviceMax":"991px","largeDeviceMin":"992px","large_device_min_alt":"1350px","quizQuestionContainer":"src-containers-Home-sections-Quiz-__Question-module___quizQuestionContainer","quizQuestionOptions":"src-containers-Home-sections-Quiz-__Question-module___quizQuestionOptions","quizQuestionOptionsItem":"src-containers-Home-sections-Quiz-__Question-module___quizQuestionOptionsItem","selected":"src-containers-Home-sections-Quiz-__Question-module___selected"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/sections/Quiz/Question.module.css
// module id = 1014
// module chunks = 1